/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const trailer_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.75 14.25a3 3 0 1 1-6 0m6 0a3 3 0 1 0-6 0m6 0h9m-15 0c-1.155 0-3 .176-3-1.5v-4.5c0-.817.683-1.5 1.5-1.5h10.5c3.268 0 6 2.732 6 6v1.5m0 0h4.5"
    />
  </svg>
)
export default trailer_medium
